import { createContext, useContext, useRef, useState } from 'react';

const MapContext = createContext({});
export const useMapContext = () => useContext(MapContext);

const MapContextProvider = ({ children, ...value }) => {
    const [mapInstance, setMapInstance] = useState(null);
    const mapToolboxRef = useRef(null);

    const removeAllMapPropertyBoundaryLayers = () => mapInstance?.data?.forEach(layer => {
        if (layer.getProperty('property_id')) {
            mapInstance.data.remove(layer);
        }
    });

    return <MapContext.Provider value={{
        mapInstance,
        setMapInstance,
        mapToolboxRef,
        removeAllMapPropertyBoundaryLayers,
        ...value
    }}>
        { children }
    </MapContext.Provider>
};

export default MapContextProvider;